/** Yields `{ year, month }` pairs from `start` through `end` inclusive (1-based months). */
export function* eachMonthInclusive(
  start: { year: number; month: number },
  end: { year: number; month: number }
): Generator<{ year: number; month: number }> {
  let year = start.year;
  let month = start.month;
  while (year < end.year || (year === end.year && month <= end.month)) {
    yield { year, month };
    month += 1;
    if (month > 12) {
      month = 1;
      year += 1;
    }
  }
}
